import styled from 'styled-components';
import { Popover } from '../../../popovers';

export const Wrapper = styled.div`
  padding-top: 8px;
`;

export const Button = styled.button`
  font-size: 14px;
  outline: none;
  border: unset;
  cursor: pointer;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.fontSilverLight};
`;


export const MeetingInfoPopover = styled(Popover)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ReactQuillWrappedContainer = styled.div`
  min-width: 150px;
  max-width: 350px;
`;




// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-info/styles.js